(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["players-and-poolhall-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const ctaButton = document.querySelector('.highlight__cta a');
    if (ctaButton) {
      ctaButton.addEventListener('click', function(event) {
        event.preventDefault();
        const url = this.getAttribute('href');
        if (url) {
          window.location.href = url;
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pooleventsection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const ctaButton = document.querySelector('.content-section__cta-button');
    ctaButton.addEventListener('click', function() {
      // Add your custom logic here, e.g., open a modal or redirect to a contact page
      console.log('Talk to an Expert button clicked');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab-content-section"] && !Shopify.designMode) return;
  try {
    
  // JS for displaying all the content and other events based on the tab buttons
  document.addEventListener('DOMContentLoaded', function () {
    // Function to toggle visibility of slider buttons based on collection requirement
    function updateSliderButtonsVisibility() {
      // Iterate over each tab button and associated slider
      document.querySelectorAll('.tab-collection-button').forEach((tabButton) => {
        const collectionId = tabButton.dataset.collectionId;
        const sliderButtons = document.querySelector(`.slider-buttons[data-controls="${collectionId}"]`);
        const slider = document.querySelector(`#Slider-${collectionId}`);

        if (slider && sliderButtons) {
          // Check if the collection should have a slider
          if (slider.scrollWidth > slider.clientWidth) {
            sliderButtons.style.display = 'flex'; // Show slider buttons if slider is scrollable
          } else {
            sliderButtons.style.display = 'none'; // Hide slider buttons if slider is not scrollable
          }
        }
      });
    }

    // Initial update
    updateSliderButtonsVisibility();

    // Update visibility when switching tabs
    document.querySelectorAll('.tab-collection-button').forEach((button) => {
      button.addEventListener('click', function () {
        // Delay the update to ensure slider content is loaded
        setTimeout(updateSliderButtonsVisibility, 100);
      });
    });

    // Optionally, observe for changes if sliders or tabs are dynamically modified
    const observer = new MutationObserver(updateSliderButtonsVisibility);
    observer.observe(document.body, { childList: true, subtree: true });
  });

  document.addEventListener('DOMContentLoaded', function () {
    const tabButtons = document.querySelectorAll('.tab-collection-button');
    const collections = document.querySelectorAll('.collection-content');
    const viewMoreButtons = document.querySelectorAll('.view-more-button');

    // Show the first collection by default
    if (collections.length > 0) {
      collections[0].classList.remove('hidden');
    }
    if (tabButtons.length > 0) {
      tabButtons[0].classList.add('active');
    }

    // Function to update the visibility of the "View More" buttons
    function updateViewMoreButtons() {
      // Get the collection ID of the active tab button
      const activeTabButton = document.querySelector('.tab-collection-button.active');
      const activeCollectionId = activeTabButton
        ? activeTabButton.getAttribute('data-collection-id').split('-').pop()
        : null;

      viewMoreButtons.forEach((button) => {
        // Extract the collection ID from the button's class
        const classNames = button.className.split(' ');
        const viewAllClass = classNames.find((className) => className.startsWith('view-all-'));
        const buttonCollectionId = viewAllClass ? viewAllClass.split('-')[2] : null; // Extract block ID from class

        if (buttonCollectionId === activeCollectionId) {
          button.classList.remove('hidden');
        } else {
          button.classList.add('hidden');
        }
      });
    }
    updateViewMoreButtons();

    // Click event for tab buttons
    tabButtons.forEach((button) => {
      button.addEventListener('click', function (event) {
        event.preventDefault();

        // Remove the 'hidden' class from all collections and hide them
        collections.forEach((collection) => collection.classList.add('hidden'));

        // Get the collection ID from the clicked button
        const collectionId = this.getAttribute('data-collection-id');

        // Show the selected collection
        const activeCollection = document.getElementById(collectionId);
        if (activeCollection) {
          activeCollection.classList.remove('hidden');
        }

        // Remove active class from all buttons and add it to the clicked one
        tabButtons.forEach((btn) => btn.classList.remove('active'));
        this.classList.add('active');

        // Update the visibility of the "View More" buttons
        updateViewMoreButtons();
      });
    });
  });

  // header slider buttons in the tab buttons
  document.addEventListener('DOMContentLoaded', function () {
    const tabButtonsContainer = document.getElementById('tab-buttons');
    const prevButtonContainer = document.querySelector('.slider-button--prev-container');
    const nextButtonContainer = document.querySelector('.slider-button--next-container');
    const prevButton = document.querySelector('.slider-button--prev');
    const nextButton = document.querySelector('.slider-button--next');

    // Calculate the width of one button
    const buttonWidth = tabButtonsContainer.querySelector('.tab-collection-button').offsetWidth;

    function updateButtonVisibility() {
      const scrollLeft = tabButtonsContainer.scrollLeft;
      const clientWidth = tabButtonsContainer.clientWidth;
      const scrollWidth = tabButtonsContainer.scrollWidth;

      if (scrollLeft === 0) {
        prevButtonContainer.style.display = 'none';
      } else {
        prevButtonContainer.style.display = 'flex';
      }

      if (scrollLeft + clientWidth >= scrollWidth - 1) {
        nextButtonContainer.style.display = 'none'; // Use a small threshold to handle rounding issues
      } else {
        nextButtonContainer.style.display = 'flex';
      }
    }

    function applyScrollableTabsClass() {
      const isScrollable =
        window.innerWidth < 560 || tabButtonsContainer.querySelectorAll('.tab-collection-button').length > 3;

      if (isScrollable) {
        tabButtonsContainer.classList.add('scrollable-tabs');
      } else {
        tabButtonsContainer.classList.remove('scrollable-tabs');
      }
    }

    // Initial check
    applyScrollableTabsClass();
    updateButtonVisibility();

    // Update on window resize
    window.addEventListener('resize', function () {
      applyScrollableTabsClass();
      updateButtonVisibility();
    });

    prevButton.addEventListener('click', function () {
      tabButtonsContainer.scrollBy({
        left: -buttonWidth,
        behavior: 'smooth',
      });
    });

    nextButton.addEventListener('click', function () {
      tabButtonsContainer.scrollBy({
        left: buttonWidth,
        behavior: 'smooth',
      });
    });

    tabButtonsContainer.addEventListener('scroll', updateButtonVisibility);
  });

  // product slider buttons
  document.addEventListener('DOMContentLoaded', function () {
    function removeDisabledAttribute() {
      const buttons = document.querySelectorAll('.tab-slider-button');
      buttons.forEach((button) => {
        if (button.hasAttribute('disabled')) {
          button.removeAttribute('disabled');
        }
      });
    }

    // Initial removal of disabled attribute
    removeDisabledAttribute();

    // Set up a MutationObserver to watch for changes
    const observer = new MutationObserver(() => {
      removeDisabledAttribute();
    });

    // Observe all buttons for attribute changes
    document.querySelectorAll('.slider-button').forEach((button) => {
      observer.observe(button, { attributes: true });
    });

    // Ensure new buttons added to the DOM are also monitored
    const observerForNewNodes = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE && node.matches('.slider-button')) {
            observer.observe(node, { attributes: true });
          }
        });
      });
    });

    observerForNewNodes.observe(document.body, { childList: true, subtree: true });
  });

  document.addEventListener('DOMContentLoaded', function () {
    const productSliderButtons = document.querySelector('.product-slider-buttons');

    // Find the first slider button generated
    const firstSliderButton = productSliderButtons.querySelector('.slider-buttons');

    // Function to handle tab click
    function handleTabClick(event) {
      // Get the ID of the clicked tab
      const selectedButtonId = event.target.id;
      const index = selectedButtonId.split('-')[1];
      // Check if the slider button with the current index exists
      const sliderButton = productSliderButtons.querySelector(`#slide-button-${index}`);
      if (sliderButton) {
        var sliderButtonIndex = productSliderButtons.querySelector(`#slide-button-${index}`).id.split('-')[2];
      }
      // Hide all slider buttons
      document.querySelectorAll('.tab-slider-buttons').forEach((button) => {
        button.style.display = 'none';
      });

      // Show the first slider button if it exists
      if (index == sliderButtonIndex) {
        firstSliderButton.style.display = 'flex'; // or 'block' depending on your design
      } else if (sliderButton == null) {
        firstSliderButton.style.display = 'none'; // or 'block' depending on your design
      }
    }

    // Attach click event listeners to tab buttons
    document.querySelectorAll('.tab-collection-button').forEach((button) => {
      button.addEventListener('click', handleTabClick);
    });

    // Initial handling on page load if needed
    const initialActiveButton = document.querySelector('.tab-collection-button.active');
    if (initialActiveButton) {
      handleTabClick({ target: initialActiveButton });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
